export default __webpack_public_path__ + "static/media/50.0584a2eb.jpg";